import { ShotStatusEnum } from '../../shared/models/shot-status.enum';

export class UpdateShotStatus {
  public ShotId: number;
  public StatusId: ShotStatusEnum;
  public Comments: string;

  constructor(shotId: number, statusId: ShotStatusEnum, comments?: string) {
    this.ShotId = shotId;
    this.StatusId = statusId;
    this.Comments = comments || null;
  }
}
